import { render, staticRenderFns } from "./mentionable_create.vue?vue&type=template&id=0c594e32&"
import script from "./mentionable_create.vue?vue&type=script&lang=js&"
export * from "./mentionable_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports